/*
* global parent class to out controllers
*/
import Engine from "../Engine/Engine";

export default class {
    constructor(dom, widgetName) {
        this.domNode = document.getElementById(dom);
        this.WidgetName = widgetName ? widgetName : "Widget";
        this.id = this.domNode.id;

        //add this widgets to global listener
        Engine.widgetsList.add(this.id,this);
    }
}